module.exports = __webpack_public_path__ + "img/rightjt.32b4a89a.svg";